export class AuthenticationFailedError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, AuthenticationFailedError.prototype);
  }
}
